import { Routes } from '@angular/router';
import { AppLayoutComponent } from '@/core/layout/components/app-layout.component';
import { AclGuard } from '@/core/guards/acl.guard';
import { Page404Component } from '@/core/pages/error/page404.component';
import { Page401Component } from '@/core/pages/error/page401.component';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayoutComponent,
        canActivate: [AclGuard],
        canActivateChild: [AclGuard],
        children: [
            {
                path: 'security',
                data: { acl: { scope: 'any', acl: ['read:authorities', 'read:roles'] } },
                loadChildren: () => import('@/core/pages/security/security.routes')
            },
            {
                path: '',
                loadChildren: () => import('@/pages/pages.routes')
            }
        ]
    },
    {
        path: '404',
        component: Page404Component
    },
    {
        path: '401',
        component: Page401Component
    },
    { path: '**', redirectTo: '/404' }
];
